export default __webpack_public_path__ + "static/media/030-water slide.f5c73244.svg";